import { AnyAction } from 'redux'

export const TAGS = '[tags]'
export const GET_TAGS = `${TAGS} Get`

export const getTags = (prefix: string): AnyAction => ({
  type: GET_TAGS,
  payload: prefix,
})
